const methods = [
    {
        txType: 'NetellerWithdrawal',
        service: null,
        providerType: 'NETELLER',
        fields: async () => (await import('./neteller-withdrawal_none_neteller.js')).fields,
    },
    {
        txType: 'CreditcardWithdrawal',
        service: null,
        providerType: 'CREDITCARD',
        fields: async () => (await import('./creditcard-withdrawal_none_creditcard.js')).fields,
    },
    {
        txType: 'BankLocalWithdrawal',
        service: null,
        providerType: 'BANKLOCAL',
        fields: async () => (await import('./bank-local-withdrawal_none_banklocal.js')).fields,
    },
    {
        txType: 'BankIBANWithdrawal',
        service: null,
        providerType: 'BANKIBAN',
        fields: async () => (await import('./bank-ibanwithdrawal_none_bankiban.js')).fields,
    },
    {
        txType: 'PaysafecardWithdrawal',
        service: null,
        providerType: 'PAYSAFECARD',
        fields: async () => (await import('./paysafecard-withdrawal_none_paysafecard.js')).fields,
    },
    {
        txType: 'BankIntlWithdrawal',
        service: null,
        providerType: 'BANKINTL',
        fields: async () => (await import('./bank-intl-withdrawal_none_bankintl.js')).fields,
    },
    {
        txType: 'EcoPayzWithdrawal',
        service: null,
        providerType: 'ECOPAYZ',
        fields: async () => (await import('./eco-payz-withdrawal_none_ecopayz.js')).fields,
    },
    {
        txType: 'PayPalWithdrawal',
        service: null,
        providerType: 'PAYPAL',
        fields: async () => (await import('./pay-pal-withdrawal_none_paypal.js')).fields,
    },
    {
        txType: 'EnvoyWithdrawal',
        service: null,
        providerType: 'ENVOY',
        fields: async () => (await import('./envoy-withdrawal_none_envoy.js')).fields,
    },
    {
        txType: 'ChinaUnionPayWithdrawal',
        service: null,
        providerType: 'CHINAUNIONPAY',
        fields: async () => (await import('./china-union-pay-withdrawal_none_chinaunionpay.js')).fields,
    },
    {
        txType: 'AstroPayDirectWithdrawal',
        service: null,
        providerType: 'ASTROPAYDIRECT',
        fields: async () => (await import('./astro-pay-direct-withdrawal_none_astropaydirect.js')).fields,
    },
    {
        txType: 'VenusPointWithdrawal',
        service: null,
        providerType: 'VENUSPOINT',
        fields: async () => (await import('./venus-point-withdrawal_none_venuspoint.js')).fields,
    },
    {
        txType: 'SkrillWithdrawal',
        service: null,
        providerType: 'SKRILL',
        fields: async () => (await import('./skrill-withdrawal_none_skrill.js')).fields,
    },
    {
        txType: 'MiFinityEWalletWithdrawal',
        service: null,
        providerType: 'MIFINITY',
        fields: async () => (await import('./mi-finity-ewallet-withdrawal_none_mifinity.js')).fields,
    },
    {
        txType: 'QiwiWithdrawal',
        service: null,
        providerType: 'QIWI',
        fields: async () => (await import('./qiwi-withdrawal_none_qiwi.js')).fields,
    },
    {
        txType: 'IWalletWithdrawal',
        service: null,
        providerType: 'IWALLET',
        fields: async () => (await import('./iwallet-withdrawal_none_iwallet.js')).fields,
    },
    {
        txType: 'Wallet88Withdrawal',
        service: null,
        providerType: 'WALLET88',
        fields: async () => (await import('./wallet88-withdrawal_none_wallet88.js')).fields,
    },
    {
        txType: 'BankIntIBANWithdrawal',
        service: null,
        providerType: 'BANKINTIBAN',
        fields: async () => (await import('./bank-int-ibanwithdrawal_none_bankintiban.js')).fields,
    },
    {
        txType: 'MuchBetterWithdrawal',
        service: null,
        providerType: 'MUCHBETTER',
        fields: async () => (await import('./much-better-withdrawal_none_muchbetter.js')).fields,
    },
    {
        txType: 'SiirtoWithdrawal',
        service: null,
        providerType: 'SIIRTO',
        fields: async () => (await import('./siirto-withdrawal_none_siirto.js')).fields,
    },
    {
        txType: 'PaykasaWithdrawal',
        service: null,
        providerType: 'PAYKASA',
        fields: async () => (await import('./paykasa-withdrawal_none_paykasa.js')).fields,
    },
    {
        txType: 'CreditcardWithdrawal',
        service: 'ENTROPAY',
        providerType: 'CREDITCARD',
        fields: async () => (await import('./creditcard-withdrawal_entropay_creditcard.js')).fields,
    },
    {
        txType: 'JetonWithdrawal',
        service: null,
        providerType: 'JETON',
        fields: async () => (await import('./jeton-withdrawal_none_jeton.js')).fields,
    },
    {
        txType: 'InteracWithdrawal',
        service: null,
        providerType: 'INTERAC',
        fields: async () => (await import('./interac-withdrawal_none_interac.js')).fields,
    },
    {
        txType: 'OzanWithdrawal',
        service: null,
        providerType: 'OZAN',
        fields: async () => (await import('./ozan-withdrawal_none_ozan.js')).fields,
    },
    {
        txType: 'NeosurfVoucherWithdrawal',
        service: null,
        providerType: 'NEOSURFVOUCHER',
        fields: async () => (await import('./neosurf-voucher-withdrawal_none_neosurfvoucher.js')).fields,
    },
    {
        txType: 'EcoBanqWithdrawal',
        service: null,
        providerType: 'ECOBANQ',
        fields: async () => (await import('./eco-banq-withdrawal_none_ecobanq.js')).fields,
    },
    {
        txType: 'BankDomesticWithdrawal',
        service: null,
        providerType: 'BANKDOMESTIC',
        fields: async () => (await import('./bank-domestic-withdrawal_none_bankdomestic.js')).fields,
    },
    {
        txType: 'SticpayWithdrawal',
        service: null,
        providerType: 'STICPAY',
        fields: async () => (await import('./sticpay-withdrawal_none_sticpay.js')).fields,
    },
    {
        txType: 'SparkWithdrawal',
        service: null,
        providerType: 'SPARK',
        fields: async () => (await import('./spark-withdrawal_none_spark.js')).fields,
    },
    {
        txType: 'PaySecWithdrawal',
        service: null,
        providerType: 'PAYSEC',
        fields: async () => (await import('./pay-sec-withdrawal_none_paysec.js')).fields,
    },
    {
        txType: 'Pay4FunWithdrawal',
        service: null,
        providerType: 'PAY4FUN',
        fields: async () => (await import('./pay4-fun-withdrawal_none_pay4-fun.js')).fields,
    },
    {
        txType: 'BestPayWithdrawal',
        service: null,
        providerType: 'BESTPAY',
        fields: async () => (await import('./best-pay-withdrawal_none_bestpay.js')).fields,
    },
    {
        txType: 'InteracDirectWithdrawal',
        service: null,
        providerType: 'INTERACDIRECT',
        fields: async () => (await import('./interac-direct-withdrawal_none_interacdirect.js')).fields,
    },
    {
        txType: 'InovapayWalletWithdrawal',
        service: null,
        providerType: 'INOVAPAYWALLET',
        fields: async () => (await import('./inovapay-wallet-withdrawal_none_inovapaywallet.js')).fields,
    },
    {
        txType: 'CryptoCurrencyWithdrawal',
        service: 'CRYPTOPAY',
        providerType: 'CRYPTOCURRENCY',
        fields: async () => (await import('./crypto-currency-withdrawal_cryptopay_cryptocurrency.js')).fields,
    },
    {
        txType: 'PremierPayDirectWithdrawal',
        service: 'DIRECTCREDIT',
        providerType: 'PREMIERPAYDIRECT',
        fields: async () => (await import('./premier-pay-direct-withdrawal_directcredit_premierpaydirect.js')).fields,
    },
    {
        txType: 'EPaybgWithdrawal',
        service: null,
        providerType: 'EPAYBG',
        fields: async () => (await import('./epaybg-withdrawal_none_epaybg.js')).fields,
    },
    {
        txType: 'LuxonPayWalletWithdrawal',
        service: null,
        providerType: 'LUXONPAY',
        fields: async () => (await import('./luxon-pay-wallet-withdrawal_none_luxonpay.js')).fields,
    },
    {
        txType: 'CryptoCurrencyWithdrawal',
        service: 'BITPACE',
        providerType: 'CRYPTOCURRENCY',
        fields: async () => (await import('./crypto-currency-withdrawal_bitpace_cryptocurrency.js')).fields,
    },
    {
        txType: 'VCreditosWalletWithdrawal',
        service: null,
        providerType: 'VCREDITOS',
        fields: async () => (await import('./vcreditos-wallet-withdrawal_none_vcreditos.js')).fields,
    },
    {
        txType: 'ECommPayWalletWithdrawal',
        service: 'QIWI',
        providerType: 'ECOMMPAY',
        fields: async () => (await import('./ecomm-pay-wallet-withdrawal_qiwi_ecommpay.js')).fields,
    },
    {
        txType: 'ECommPayWalletWithdrawal',
        service: 'PAPARA',
        providerType: 'ECOMMPAY',
        fields: async () => (await import('./ecomm-pay-wallet-withdrawal_papara_ecommpay.js')).fields,
    },
    {
        txType: 'ECommPayWalletWithdrawal',
        service: 'YANDEX',
        providerType: 'ECOMMPAY',
        fields: async () => (await import('./ecomm-pay-wallet-withdrawal_yandex_ecommpay.js')).fields,
    },
    {
        txType: 'ECommPayWalletWithdrawal',
        service: 'WEBMONEY',
        providerType: 'ECOMMPAY',
        fields: async () => (await import('./ecomm-pay-wallet-withdrawal_webmoney_ecommpay.js')).fields,
    },
    {
        txType: 'AstroPayBankWithdrawal',
        service: null,
        providerType: 'ASTROPAYBANK',
        fields: async () => (await import('./astro-pay-bank-withdrawal_none_astropaybank.js')).fields,
    },
    {
        txType: 'BankLocalWithdrawal',
        service: 'VICUS',
        providerType: 'BANKLOCAL',
        fields: async () => (await import('./bank-local-withdrawal_vicus_banklocal.js')).fields,
    },
    {
        txType: 'PiastrixWalletWithdrawal',
        service: null,
        providerType: 'PIASTRIX',
        fields: async () => (await import('./piastrix-wallet-withdrawal_none_piastrix.js')).fields,
    },
    {
        txType: 'PayRetailersWithdrawal',
        service: null,
        providerType: 'PAYRETAILERS',
        fields: async () => (await import('./pay-retailers-withdrawal_none_payretailers.js')).fields,
    },
    {
        txType: 'InteracWithdrawal',
        service: 'INTERAC_ETRANSFER',
        providerType: 'INTERAC',
        fields: async () => (await import('./interac-withdrawal_interac-etransfer_interac.js')).fields,
    },
    {
        txType: 'CryptoCurrencyWithdrawal',
        service: 'MONEYBITE',
        providerType: 'CRYPTOCURRENCY',
        fields: async () => (await import('./crypto-currency-withdrawal_moneybite_cryptocurrency.js')).fields,
    },
    {
        txType: 'CreditcardWithdrawal',
        service: 'DIRECTA24',
        providerType: 'CREDITCARD',
        fields: async () => (await import('./creditcard-withdrawal_directa24_creditcard.js')).fields,
    },
    {
        txType: 'InovapayBankWithdrawal',
        service: null,
        providerType: 'INOVAPAYBANK',
        fields: async () => (await import('./inovapay-bank-withdrawal_none_inovapaybank.js')).fields,
    },
];

export { methods };
